import React from "react";
import { Button } from "./shared/Button";
import { BiSolidChevronUp } from "react-icons/bi";
import { Dropdown } from "./shared/Dropdown";
import { CodeFolder } from "../shared/icons/icons";
import { Tooltip } from "antd";
import MainMenu from "./menu/MainMenu";
import { FormattedMessage } from "react-intl";
import { classNames } from "../../utils";

export interface FABMenuProps {
  hasCode: boolean;
  showModal: () => void;
}

export const FABMenu: React.FC<FABMenuProps> = ({ showModal, hasCode }) => {
  return (
    <div className="absolute bottom-0 right-0 py-4 pr-4 z-[999]">
      <Dropdown
        disabled={!hasCode}
        menu={<MainMenu showModal={showModal} />}
        position="bottom-10 -left-full"
      >
        <Tooltip
          placement="right"
          title={<FormattedMessage id="code" />}
          color="white"
          overlayInnerStyle={{ color: "black", fontFamily: "Alata" }}
          className="h-auto !flex"
        >
          <button
            disabled={!hasCode}
            className={classNames(
              !hasCode
                ? "bg-gray-300"
                : "bg-riders-green hover:bg-riders-green-dark",
              "rounded-full h-10 w-10 ml-8 flex items-center justify-center text-white"
            )}
          >
            <CodeFolder size={22} />
          </button>
        </Tooltip>
      </Dropdown>
    </div>
  );
};
